export default __webpack_public_path__ + "static/media/lock-cycle.84b5d07e.svg";